import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import successIcon from 'assets/images/success-icon.svg';
import error from 'assets/images/error-icon.svg';
import { deleteToast } from 'modules/common/commonSlice';
import { ToastCloseBtn, ToastIcon, ToastMessage, ToastWrapper } from './Toast.style';

const toastTypes = {
  success: {
    icon: successIcon,
    iconColor: 'success',
  },
  error: {
    icon: error,
    iconColor: 'error',
  },
};

const Toast = ({ message, type }) => {
  const timerID = useRef(null);
  const dispatch = useDispatch();
  const { icon, iconColor, id } = toastTypes[type];
  const [dismissed, setDismissed] = useState(false);

  const handleDismiss = () => {
    setDismissed(true);
    setTimeout(() => {
      dispatch(deleteToast(id));
    }, 400);
  };

  useEffect(() => {
    timerID.current = setTimeout(() => {
      handleDismiss();
    }, 4000);

    return () => {
      clearTimeout(timerID.current);
    };
  }, []);

  return (
    <ToastWrapper ref={timerID} bgolor={iconColor} dismissed={dismissed}>
      <ToastIcon src={icon} />
      <ToastMessage>{message}</ToastMessage>
      <ToastCloseBtn onClick={handleDismiss} />
    </ToastWrapper>
  );
};

export default Toast;
